import { Component, OnInit } from '@angular/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';

@Component({
  selector: 'app-application-apps-view',
  templateUrl: './view.component.html',
})
export class ApplicationAppsViewComponent implements OnInit {
  record: any = {};
  i: any;

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    public http: _HttpClient
  ) { }

  ngOnInit(): void {
    this.http.get(`api/v1/sysrRegisterApp/${this.record.appId}`).subscribe(res => this.i = res);
  }

  close() {
    this.modal.destroy();
  }
}
